import { Box, IconButton } from "@mui/material";
import React from "react";
import { TagList } from "../calendar";
import Slot, { slotStatus } from "./Slot";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ResourceExtraInfo from "./ResourceExtraInfo";
import { faChairOffice, faLockKeyhole } from "@fortawesome/pro-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import CancelOrWaitAppointmentDialog from "./CancelOrWaitAppointmentDialog";

export default function CalendarSlot2({
  appointments,
  setChangeEmployee,
  status,
  setEditEvent,
}) {
  const [showCancelOrWaitDialog, setShowCancelOrWaitDialog] =
    React.useState(false);
  const slotProps = React.useMemo(() => {
    return {
      n: 2,
      appointments: appointments,
      setEditEvent: setEditEvent,
    };
  }, [appointments, setEditEvent]);

  return (
    <>
      <Box display="flex">
        <TagList appointments={appointments} />
        <Slot variant={status} {...slotProps}>
          {appointments.length !== 0 && setEditEvent != null && (
            <IconButton
              size="small"
              sx={{
                position: "absolute",
                top: "0",
                right: "0",
                padding: "0.2rem",
              }}
              onClick={async (e) => {
                e.stopPropagation();
                setShowCancelOrWaitDialog(true);
              }}
            >
              <FontAwesomeIcon icon={faXmark} fontSize="1rem" fixedWidth />
            </IconButton>
          )}
          {appointments.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <FontAwesomeIcon
                icon={
                  status === slotStatus.EMPTY ? faChairOffice : faLockKeyhole
                }
                style={{ fontSize: slotStatus.EMPTY ? "2rem" : "3.5rem" }}
              />
            </Box>
          ) : (
            <ResourceExtraInfo
              appointments={appointments}
              setChangeEmployee={setChangeEmployee}
            />
          )}
        </Slot>
      </Box>
      {showCancelOrWaitDialog && (
        <CancelOrWaitAppointmentDialog
          appointments={appointments}
          close={() => setShowCancelOrWaitDialog(false)}
        />
      )}
    </>
  );
}
